import { api } from './client';

export const autocompleteApi = {
  get: () => api.get<{ colors: string[]; brands: string[]; titles: string[] }>('/autocomplete'),
};
